// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"64910560","129":"3e1260dd","304":"4a664a30","681":"64379bae","894":"9fe030d2"}[chunkId] + ".chunk.js";
};